module.exports = __webpack_public_path__ + "static/gradientTwo-1aacf32e20c96db6f621edd4c763e2f7.svg";